import { takeEvery, takeLatest, all, call, put, cancelled } from 'redux-saga/effects';

import {
  DISCOUNTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  DISCOUNTS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  DISCOUNTS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  discountsMassiveUploadSetAllowUpload,
  discountsMassiveUploadClearAllowUpload,
  discountsMassiveUploadSetVerify,
  discountsMassiveUploadClearVerify,
  discountsMassiveUploadClearUpload,
} from '../actions';

import instance from 'services/request';

import { responseOK } from 'Domains/SalesChallengeRefactor/utils';

import { discountsMassiveUpload } from '../../services';
import {
  fileTo64String,
  validateTypeAndSize,
  summaryModal,
  summaryEndModal,
} from 'common/MassiveUploads/utils';
import { messageError } from 'utils/messages';

function* workDiscountsMassiveUploadSetAllowUpload(action) {
  try {
    yield discountsMassiveUploadSetAllowUpload(action.payload);
  } catch (error) {
    yield discountsMassiveUploadClearAllowUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield discountsMassiveUploadClearAllowUpload();
    }
  }
}

function* workDiscountsMassiveUploadRequestVerify({ payload }) {
  const { file, setFileString } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const isValidFile = validateTypeAndSize(file);
    if (!isValidFile) {
      messageError(
        'El formato del archivo de carga masiva de Tabla de descuentos debe ser .xlsx y tener un tamaño máximo de 20 MB.'
      );

      return;
    }

    const file64Str = yield call(fileTo64String, file);
    yield call(setFileString, file64Str);
    const response = yield call(discountsMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: file64Str,
        overwrite: false,
        save: false,
      },
    });
    if (responseOK(response)) {
      let { data, message, allCorrectMessage } = response;

      let allCorrect = data.correct > 0 && data.totalErrors === 0;

      if (allCorrect) {
        data.allCorrectMessage = allCorrectMessage;
      }

      yield put(discountsMassiveUploadSetVerify(data));
      yield call(summaryModal, message);
    } else {
      yield put(discountsMassiveUploadClearVerify());
    }
  } catch (error) {
    yield discountsMassiveUploadClearVerify();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield discountsMassiveUploadClearVerify();
      source.cancel('cancelled Request');
    }
  }
}

function* workDiscountsMassiveUploadRequestUpload({ payload }) {
  const { history, fileString, overwrite } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const response = yield call(discountsMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: fileString,
        save: true,
        overwrite,
      },
    });
    if (responseOK(response)) {
      yield call(summaryEndModal, response.data, history, '/catalog/trade-agreement-info');
    } else {
      yield put(discountsMassiveUploadClearUpload());
    }
  } catch (error) {
    yield discountsMassiveUploadClearUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield discountsMassiveUploadClearUpload();
      source.cancel('cancelled Request');
    }
  }
}

export function* watchDiscountsMassiveUploadSetAllowUpload() {
  yield all([
    takeEvery(DISCOUNTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD, workDiscountsMassiveUploadSetAllowUpload),
  ]);
}

export function* watchDiscountsMassiveUploadRequestVerify() {
  yield all([
    takeEvery(DISCOUNTS_MASSIVE_UPLOAD_REQUEST_VERIFY, workDiscountsMassiveUploadRequestVerify),
  ]);
}

export function* watchDiscountsMassiveUploadRequestUpload() {
  yield takeLatest(
    DISCOUNTS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
    workDiscountsMassiveUploadRequestUpload
  );
}
